import { ReactNode } from "react";
import { CircularProgress } from "@mui/material";
import { AlertInCircleIcon, CheckInEmptyCircleIcon } from "../../../images";
import { ActivitiesStatus } from "../../../../types/enums";

export const StatusIcon = ({ status }: { status: ActivitiesStatus }) => {
  const values: Record<ActivitiesStatus, ReactNode> = {
    in_progress: (
      <CircularProgress size={20} sx={{ color: "#3279B3", flexShrink: 0 }} />
    ),
    failed: <AlertInCircleIcon width="20px" height="20px" />,
    completed: <CheckInEmptyCircleIcon />,
    queued: null,
    updating: null,
  };
  return <>{values[status]}</>;
};
